import { render, staticRenderFns } from "./sidebar_invite_members.vue?vue&type=template&id=6e89a7b3&"
import script from "./sidebar_invite_members.vue?vue&type=script&lang=js&"
export * from "./sidebar_invite_members.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports